import memoize from 'lodash/memoize';

export const utilFileSize = memoize((value: number, characters = 2) => {
  if (value < 1024) return `${value} B`;
  if (value < 1024 ** 2) return `${(value / 1024).toFixed(characters)} kB`;
  if (value < 1024 ** 3) return `${(value / 1024 ** 2).toFixed(characters)} MB`;
  return `${(value / 1024 ** 3).toFixed(characters)} GB`;
});
